"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class CompanyInfo extends React.Component {
    render() {
        return React.createElement("div", { className: "text-center col-xs-12" }, React.createElement("h3", null, " ", this.props.data.name));
    }
}
exports.default = CompanyInfo;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/feedback/component/CompanyInfo.tsx
// module id = 1356
// module chunks = 1